import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, Inject, EventEmitter, Output, HostListener, NgModule } from '@angular/core';
import * as i1 from '@ngrx/store';
import { LoadMembersOnceAction, getTeamMembers, entryAvailable, LoadTeamOnceAction, getTeam, getUser, exists, getUserTeams, distinct, LoadUserTeamsAction } from '@play/state';
import { filter, map, startWith, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject, combineLatest, interval, Subject } from 'rxjs';
import { sortWith, ascend, compose, toLower } from 'ramda';
import { canEditTeam, isLeader, getCompleteName } from '@play/utility/team';
import * as i4 from '@play/common';
import { ESCAPE, CommonsModule, CommonsErrorModule, CommonsLoadingModule, CommonsComponentModule, CommonsLocationModule, SvgIconsModule } from '@play/common';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import { teamMemberPermissionMatcher } from '@play/api-typings';
import * as i2 from '@play/translate';
import { TranslationModule } from '@play/translate';
import * as i5$1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i2$1 from '@play/api-client';

const teamListItemActionsTexts = {
    "user-team-list:edit-team": "Edit team",
    "user-team-list:premium-status": "Premium Status",
    "user-team-list:trusted-status": "Trusted Status",
    "user-team-list:manage-team": "Manage team",
    "user-team-list:delete-team": "Delete team",
    "user-team-list:leave-team": "Leave team",
    "user-team-list:last-member": "You are the last member in this team. Please delete the team instead of leaving it.",
    "user-team-list:last-leader": "You cannot leave this team since you are the last leader. Please transfer ownership before leaving the team.",
    "user-team-list:no-permission": "You have insufficient permissions for this action.",
};

const teamListTexts = {
    // Team List Header
    "user-team-list:header": "My Teams",
    "user-team-list:header-join-team": "Join Team",
    "user-team-list:header-create-team": "Create Team",
    // Team List Logged Out
    "user-team-list:login-action-description": "Please log in to see your teams",
    "user-team-list:login-action-label": "Login/Register",
    "user-team-list:no-team-description": "You are currently not a member of any teams. Why not join or create one?",
};

function TeamListItemInformationComponent_trusted_icon_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "trusted-icon", 8);
} }
function TeamListItemInformationComponent_premium_icon_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "premium-icon", 8);
} }
function TeamListItemInformationComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementStart(4, "a", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "user-team-list:part-of"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", ctx_r2.parentTeam.name)("locationHref", ctx_r2.parentTeamLink);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.parentTeam.name, " ");
} }
class TeamListItemInformationComponent {
    constructor(links) {
        this.links = links;
    }
    ngOnChanges() {
        if (this.parentTeam) {
            this.parentTeamLink = this.links.team(+this.parentTeam.id);
        }
        this.teamLink = this.links.team(this.teamId);
    }
}
TeamListItemInformationComponent.ɵfac = function TeamListItemInformationComponent_Factory(t) { return new (t || TeamListItemInformationComponent)(i0.ɵɵdirectiveInject(i4.LinkService)); };
TeamListItemInformationComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TeamListItemInformationComponent, selectors: [["user-team-list-item-information"]], inputs: { teamName: "teamName", teamSuffix: "teamSuffix", teamTrusted: "teamTrusted", teamPremium: "teamPremium", teamRegion: "teamRegion", teamId: "teamId", parentTeam: "parentTeam" }, features: [i0.ɵɵNgOnChangesFeature], decls: 10, vars: 8, consts: [[1, "c-user-team-list-team__wrapper"], [1, "c-user-team-list-team__information"], [3, "country"], [1, "c-user-team-list-team__link"], [3, "title", "locationHref"], [1, "c-user-team-list-team__icons"], ["class", "c-user-team-list-team__icons__icon", 4, "ngIf"], ["class", "c-user-team-list-team__information", 4, "ngIf"], [1, "c-user-team-list-team__icons__icon"], [1, "c-user-team-list-team__information__parent-team"]], template: function TeamListItemInformationComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "country-flag", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "a", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵtemplate(7, TeamListItemInformationComponent_trusted_icon_7_Template, 1, 0, "trusted-icon", 6);
        i0.ɵɵtemplate(8, TeamListItemInformationComponent_premium_icon_8_Template, 1, 0, "premium-icon", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, TeamListItemInformationComponent_div_9_Template, 6, 6, "div", 7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("country", ctx.teamRegion);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("title", ctx.teamName)("locationHref", ctx.teamLink);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate2(" ", ctx.teamName, " ", ctx.teamSuffix, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.teamTrusted);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.teamPremium);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.parentTeam);
    } }, directives: [i4.CountryFlagComponent, i4.LocationDirective, i5.NgIf, i4.TrustedIconComponent, i4.PremiumIconComponent], pipes: [i2.TranslatePipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TeamListItemInformationComponent, [{
        type: Component,
        args: [{
                selector: "user-team-list-item-information",
                templateUrl: "./team-list-item-information.component.html",
                styleUrls: ["./team-list-item-information.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i4.LinkService }]; }, { teamName: [{
            type: Input
        }], teamSuffix: [{
            type: Input
        }], teamTrusted: [{
            type: Input
        }], teamPremium: [{
            type: Input
        }], teamRegion: [{
            type: Input
        }], teamId: [{
            type: Input
        }], parentTeam: [{
            type: Input
        }] }); })();

function TeamListItemActionsComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 1);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("locationHref", ctx_r0.teamEditUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "user-team-list:edit-team"), " ");
} }
function TeamListItemActionsComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("tooltip", i0.ɵɵpipeBind1(2, 2, "user-team-list:no-permission"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "user-team-list:edit-team"), " ");
} }
function TeamListItemActionsComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 1);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("locationHref", ctx_r2.teamAdminUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "user-team-list:manage-team"), " ");
} }
function TeamListItemActionsComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("tooltip", i0.ɵɵpipeBind1(2, 2, "user-team-list:no-permission"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "user-team-list:manage-team"), " ");
} }
function TeamListItemActionsComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 6);
    i0.ɵɵlistener("click", function TeamListItemActionsComponent_ng_container_18_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.leaveTeam(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "user-team-list:leave-team"), " ");
} }
function TeamListItemActionsComponent_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 7);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("tooltip", ctx_r5.leaveTeamDisabledText);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "user-team-list:leave-team"), " ");
} }
function TeamListItemActionsComponent_ng_container_21_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 6);
    i0.ɵɵlistener("click", function TeamListItemActionsComponent_ng_container_21_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.deleteTeam(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "user-team-list:delete-team"), " ");
} }
function TeamListItemActionsComponent_ng_container_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("tooltip", i0.ɵɵpipeBind1(2, 2, "user-team-list:no-permission"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "user-team-list:delete-team"), " ");
} }
class TeamListItemActionsComponent {
    constructor(linkService, dialogs, translation) {
        this.linkService = linkService;
        this.dialogs = dialogs;
        this.translation = translation;
    }
    ngOnChanges() {
        this.teamAdminUrl = this.linkService.teamAdmin(this.teamId);
        this.teamEditUrl = this.linkService.teamEdit(this.teamId);
        this.teamPremiumUrl = this.linkService.teamPremiumStatus(this.teamId);
        this.teamTrustedUrl = this.linkService.teamTrustedStatus(this.teamId);
    }
    leaveTeam() {
        this.dialogs.openLeaveTeamDialog({ teamId: this.teamId, teamName: this.teamName, memberId: this.memberId });
    }
    deleteTeam() {
        this.dialogs.openDeleteTeamDialog({ teamId: this.teamId, teamName: this.teamName, memberId: this.memberId });
    }
}
TeamListItemActionsComponent.ɵfac = function TeamListItemActionsComponent_Factory(t) { return new (t || TeamListItemActionsComponent)(i0.ɵɵdirectiveInject(i4.LinkService), i0.ɵɵdirectiveInject("DialogService"), i0.ɵɵdirectiveInject(i2.TranslateService)); };
TeamListItemActionsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TeamListItemActionsComponent, selectors: [["user-team-list-item-actions"]], inputs: { canEditTeam: "canEditTeam", teamId: "teamId", teamName: "teamName", memberId: "memberId", isLeaveTeamDisabled: "isLeaveTeamDisabled", leaveTeamDisabledText: "leaveTeamDisabledText", isLeader: "isLeader" }, features: [i0.ɵɵNgOnChangesFeature], decls: 23, vars: 16, consts: [[1, "c-team-list-item-actions"], [1, "c-team-list-item-actions__item", "no-decoration", 3, "locationHref"], [1, "c-team-list-item-actions__divider"], [1, "u-position-relative"], [4, "ngIf"], [1, "c-team-list-item-actions__item", "c-team-list-item-actions__item--disabled", 3, "tooltip"], [1, "c-team-list-item-actions__item", "c-team-list-item-actions__item--warning", "no-decoration", 3, "click"], [1, "c-team-list-item-actions__item", "c-team-list-item-actions__item--disabled", "no-decoration", 3, "tooltip"]], template: function TeamListItemActionsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul", 0);
        i0.ɵɵelementStart(1, "li");
        i0.ɵɵelementStart(2, "a", 1);
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "li");
        i0.ɵɵelementStart(6, "a", 1);
        i0.ɵɵtext(7);
        i0.ɵɵpipe(8, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(9, "li", 2);
        i0.ɵɵelementStart(10, "li", 3);
        i0.ɵɵtemplate(11, TeamListItemActionsComponent_ng_container_11_Template, 4, 4, "ng-container", 4);
        i0.ɵɵtemplate(12, TeamListItemActionsComponent_ng_container_12_Template, 5, 6, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "li", 3);
        i0.ɵɵtemplate(14, TeamListItemActionsComponent_ng_container_14_Template, 4, 4, "ng-container", 4);
        i0.ɵɵtemplate(15, TeamListItemActionsComponent_ng_container_15_Template, 5, 6, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(16, "li", 2);
        i0.ɵɵelementStart(17, "li", 3);
        i0.ɵɵtemplate(18, TeamListItemActionsComponent_ng_container_18_Template, 4, 3, "ng-container", 4);
        i0.ɵɵtemplate(19, TeamListItemActionsComponent_ng_container_19_Template, 4, 4, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "li", 3);
        i0.ɵɵtemplate(21, TeamListItemActionsComponent_ng_container_21_Template, 4, 3, "ng-container", 4);
        i0.ɵɵtemplate(22, TeamListItemActionsComponent_ng_container_22_Template, 5, 6, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("locationHref", ctx.teamPremiumUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 12, "user-team-list:premium-status"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("locationHref", ctx.teamTrustedUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 14, "user-team-list:trusted-status"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.canEditTeam);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.canEditTeam);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.canEditTeam);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.canEditTeam);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", !ctx.isLeaveTeamDisabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isLeaveTeamDisabled);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isLeader);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isLeader);
    } }, directives: [i4.LocationDirective, i5.NgIf, i4.TooltipDirective], pipes: [i2.TranslatePipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TeamListItemActionsComponent, [{
        type: Component,
        args: [{
                selector: "user-team-list-item-actions",
                templateUrl: "./team-list-item-actions.component.html",
                styleUrls: ["./team-list-item-actions.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i4.LinkService }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }, { type: i2.TranslateService }]; }, { canEditTeam: [{
            type: Input
        }], teamId: [{
            type: Input
        }], teamName: [{
            type: Input
        }], memberId: [{
            type: Input
        }], isLeaveTeamDisabled: [{
            type: Input
        }], leaveTeamDisabledText: [{
            type: Input
        }], isLeader: [{
            type: Input
        }] }); })();

function TeamListItemComponent_user_team_list_item_actions_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "user-team-list-item-actions", 9);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("canEditTeam", ctx_r0.canEditTeam)("isLeader", ctx_r0.isLeader)("teamId", ctx_r0.team.id)("teamName", ctx_r0.team.name)("memberId", ctx_r0.user.id)("isLeaveTeamDisabled", ctx_r0.isLeaveTeamDisabled)("leaveTeamDisabledText", ctx_r0.leaveTeamDisabledText);
} }
class TeamListItemComponent {
    constructor(store, translation, linkService) {
        this.store = store;
        this.translation = translation;
        this.linkService = linkService;
        this.newDropdownNumber = new EventEmitter();
        this.teamMemberPermission = teamMemberPermissionMatcher;
    }
    toggleDropdown(number) {
        if (this.dropdownToShow === number) {
            this.newDropdownNumber.emit(null);
        }
        else {
            this.newDropdownNumber.emit(number);
        }
    }
    closeDropdown(event) {
        if (event && event.which !== ESCAPE) {
            // 27 = esc key
            return;
        }
        this.newDropdownNumber.emit(null);
    }
    onClick(event, targetElement) {
        if (this.dropdownToShow !== null) {
            this.newDropdownNumber.emit(null);
        }
    }
    ngOnInit() {
        this.store.dispatch(new LoadMembersOnceAction(+this.team.id));
        this.teamMembers$ = this.store.select(getTeamMembers(+this.team.id)).pipe(filter(entryAvailable));
        this.teamLink = this.linkService.team(this.team.id);
        this.canEditTeam = canEditTeam(this.membership);
        this.isLeader = isLeader(this.membership);
        this.teamMembers$.subscribe(teamMembers => {
            const teamLeaders = teamMembers.entry.filter(tm => tm.membership.permission === this.teamMemberPermission.leader).length;
            if (teamMembers.entry.length <= 1) {
                this.isLeaveTeamDisabled = true;
                this.leaveTeamDisabledText = this.translation.translate("user-team-list:last-member", {});
            }
            else if (this.membership.permission === this.teamMemberPermission.leader && teamLeaders <= 1) {
                this.isLeaveTeamDisabled = true;
                this.leaveTeamDisabledText = this.translation.translate("user-team-list:last-leader", {});
            }
        });
        if (this.team.parent) {
            this.store.dispatch(new LoadTeamOnceAction(+this.team.parent));
            this.parentTeam$ = this.store.select(getTeam(+this.team.parent)).pipe(filter(entryAvailable));
        }
    }
}
TeamListItemComponent.ɵfac = function TeamListItemComponent_Factory(t) { return new (t || TeamListItemComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i4.LinkService)); };
TeamListItemComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TeamListItemComponent, selectors: [["user-team-list-item"]], hostBindings: function TeamListItemComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keydown", function TeamListItemComponent_keydown_HostBindingHandler($event) { return ctx.closeDropdown($event); }, false, i0.ɵɵresolveDocument)("keypress", function TeamListItemComponent_keypress_HostBindingHandler($event) { return ctx.closeDropdown($event); }, false, i0.ɵɵresolveDocument)("click", function TeamListItemComponent_click_HostBindingHandler($event) { return ctx.onClick($event, $event.target); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { team: "team", membership: "membership", user: "user", index: "index", dropdownToShow: "dropdownToShow" }, outputs: { newDropdownNumber: "newDropdownNumber" }, decls: 10, vars: 18, consts: [[1, "c-user-team-list-team"], [1, "c-user-team-list-team__logo", 3, "title", "locationHref"], [3, "src"], [3, "teamName", "teamTrusted", "teamPremium", "teamRegion", "teamId", "teamSuffix", "parentTeam"], [1, "c-user-team-list-team__action"], [1, "c-button--outline", 3, "click"], [3, "icon"], [1, "c-user-team-list-team__action-container"], [3, "canEditTeam", "isLeader", "teamId", "teamName", "memberId", "isLeaveTeamDisabled", "leaveTeamDisabledText", 4, "ngIf"], [3, "canEditTeam", "isLeader", "teamId", "teamName", "memberId", "isLeaveTeamDisabled", "leaveTeamDisabledText"]], template: function TeamListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "a", 1);
        i0.ɵɵelement(2, "img", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "user-team-list-item-information", 3);
        i0.ɵɵpipe(4, "async");
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "play-button", 5);
        i0.ɵɵlistener("click", function TeamListItemComponent_Template_play_button_click_6_listener($event) { ctx.toggleDropdown(ctx.index); return $event.stopPropagation(); });
        i0.ɵɵelement(7, "svg-icon", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵtemplate(9, TeamListItemComponent_user_team_list_item_actions_9_Template, 1, 7, "user-team-list-item-actions", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        let tmp_9_0 = null;
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("title", ctx.team.name)("locationHref", ctx.teamLink);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("src", ctx.team.logo, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("teamName", ctx.team.name)("teamTrusted", ctx.team.trustLevel)("teamPremium", ctx.team.premium)("teamRegion", ctx.team.region)("teamId", ctx.team.id)("teamSuffix", ctx.team.suffix)("parentTeam", (tmp_9_0 = i0.ɵɵpipeBind1(4, 16, ctx.parentTeam$)) == null ? null : tmp_9_0.entry);
        i0.ɵɵadvance(4);
        i0.ɵɵstyleProp("width", 16, "px")("height", 16, "px");
        i0.ɵɵproperty("icon", "settings");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.dropdownToShow === ctx.index);
    } }, directives: [i4.LocationDirective, TeamListItemInformationComponent, i4.ButtonComponent, i4.SvgIconComponent, i5.NgIf, TeamListItemActionsComponent], pipes: [i5.AsyncPipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TeamListItemComponent, [{
        type: Component,
        args: [{
                selector: "user-team-list-item",
                templateUrl: "./team-list-item.component.html",
                styleUrls: ["./team-list-item.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.TranslateService }, { type: i4.LinkService }]; }, { team: [{
            type: Input
        }], membership: [{
            type: Input
        }], user: [{
            type: Input
        }], index: [{
            type: Input
        }], dropdownToShow: [{
            type: Input
        }], newDropdownNumber: [{
            type: Output
        }], closeDropdown: [{
            type: HostListener,
            args: ["document:keydown", ["$event"]]
        }, {
            type: HostListener,
            args: ["document:keypress", ["$event"]]
        }], onClick: [{
            type: HostListener,
            args: ["document:click", ["$event", "$event.target"]]
        }] }); })();

class TeamListItemSkeletonComponent {
}
TeamListItemSkeletonComponent.ɵfac = function TeamListItemSkeletonComponent_Factory(t) { return new (t || TeamListItemSkeletonComponent)(); };
TeamListItemSkeletonComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TeamListItemSkeletonComponent, selectors: [["user-team-list-item-skeleton"]], decls: 6, vars: 0, consts: [[1, "c-user-team-list-team"], [1, "c-skeleton__figure", "c-user-team-list-team__logo"], [1, "c-user-team-list-team__wrapper"], [1, "c-skeleton__text", "c-skeleton__text--small"]], template: function TeamListItemSkeletonComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelement(5, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } }, styles: [".c-skeleton__figure.c-user-team-list-team__logo[_ngcontent-%COMP%]{width:60px;height:60px}"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TeamListItemSkeletonComponent, [{
        type: Component,
        args: [{
                selector: "user-team-list-item-skeleton",
                templateUrl: "./team-list-item-skeleton.component.html",
                styleUrls: ["./team-list-item-skeleton.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

function TeamListComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function TeamListComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function TeamListComponent_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function TeamListComponent_ng_template_16_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function TeamListComponent_ng_template_16_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TeamListComponent_ng_template_16_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r14 = i0.ɵɵreference(7);
    const _r12 = i0.ɵɵreference(5);
    const ctx_r9 = i0.ɵɵnextContext();
    let tmp_0_0 = null;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_0_0 = i0.ɵɵpipeBind1(2, 3, ctx_r9.teams$)) == null ? null : tmp_0_0.entry.length)("ngIfThen", _r14)("ngIfElse", _r12);
} }
function TeamListComponent_ng_template_16_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "empty-call-action", 14);
    i0.ɵɵlistener("action", function TeamListComponent_ng_template_16_ng_template_2_Template_empty_call_action_action_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.navigateToLogin(); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("actionLabel", i0.ɵɵpipeBind1(1, 2, "user-team-list:login-action-label"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "user-team-list:login-action-description"), " ");
} }
function TeamListComponent_ng_template_16_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "empty-call-action");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "user-team-list:no-team-description"), " ");
} }
function TeamListComponent_ng_template_16_ng_template_6_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "user-team-list-item", 16);
    i0.ɵɵlistener("newDropdownNumber", function TeamListComponent_ng_template_16_ng_template_6_ng_container_0_Template_user_team_list_item_newDropdownNumber_1_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(3); return ctx_r22.handleDropDownNumber($event); });
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const team_r20 = ctx.$implicit;
    const i_r21 = ctx.index;
    const ctx_r19 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("index", i_r21)("team", team_r20.team)("user", i0.ɵɵpipeBind1(2, 5, ctx_r19.user$).entry)("membership", team_r20.membership)("dropdownToShow", i0.ɵɵpipeBind1(3, 7, ctx_r19.dropdownToShow$));
} }
function TeamListComponent_ng_template_16_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, TeamListComponent_ng_template_16_ng_template_6_ng_container_0_Template, 4, 9, "ng-container", 15);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(1, 1, ctx_r15.teams$).entry);
} }
function TeamListComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, TeamListComponent_ng_template_16_ng_container_0_Template, 3, 5, "ng-container", 9);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵtemplate(2, TeamListComponent_ng_template_16_ng_template_2_Template, 4, 6, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(4, TeamListComponent_ng_template_16_ng_template_4_Template, 3, 3, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(6, TeamListComponent_ng_template_16_ng_template_6_Template, 2, 3, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r10 = i0.ɵɵreference(3);
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx_r4.user$).entry)("ngIfElse", _r10);
} }
function TeamListComponent_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "user-team-list-item-skeleton");
    i0.ɵɵelement(1, "user-team-list-item-skeleton");
    i0.ɵɵelement(2, "user-team-list-item-skeleton");
} }
function TeamListComponent_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), " ");
} }
class TeamListComponent {
    constructor(store, links, location, dialogs) {
        this.store = store;
        this.links = links;
        this.location = location;
        this.dialogs = dialogs;
        this.dropdownToShow$ = new BehaviorSubject(null);
    }
    ngOnInit() {
        this.user$ = this.store.select(getUser).pipe(filter(exists));
        this.teams$ = this.store.select(getUserTeams).pipe(filter(exists), map(teams => {
            if (teams.entry) {
                return Object.assign(Object.assign({}, teams), { entry: sortWith([
                        ascend(compose(toLower, getCompleteName, (membership) => membership.team)),
                    ])(teams.entry) });
            }
            return teams;
        }));
        this.isLoading$ = this.isLoading();
        this.hasError$ = this.hasError();
        this.isReady$ = this.isReady();
    }
    hasError() {
        return combineLatest(this.user$, this.teams$).pipe(distinct(data => {
            return data.filter(entry => entry && entry.error).length !== 0;
        }));
    }
    isLoading() {
        return combineLatest(this.user$, this.teams$).pipe(distinct(data => {
            return data.filter(entry => entry && entry.loading && !entry.entry).length !== 0;
        }));
    }
    isReady() {
        return combineLatest(this.isLoading$, this.hasError$).pipe(distinct(([loading, error]) => Boolean(!loading && !error)));
    }
    navigateToLogin() {
        this.location.go(this.links.login());
    }
    createTeam() {
        this.dialogs.openCreateTeamDialog({});
    }
    joinTeam() {
        this.dialogs.openJoinTeamDialog({});
    }
    handleDropDownNumber(number) {
        this.dropdownToShow$.next(number);
    }
}
TeamListComponent.ɵfac = function TeamListComponent_Factory(t) { return new (t || TeamListComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i4.LinkService), i0.ɵɵdirectiveInject(i4.Location), i0.ɵɵdirectiveInject("DialogService")); };
TeamListComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TeamListComponent, selectors: [["user-team-list"]], decls: 22, vars: 22, consts: [[1, "c-team-list"], [1, "c-team-list__header", 3, "headerTitle", "userPage"], [1, "c-button--secondary", 3, "clicked"], [1, "c-button--primary", 3, "clicked"], [1, "c-user-team-list"], [4, "ngIf", "ngIfThen"], ["ready", ""], ["loading", ""], ["error", ""], [4, "ngIf", "ngIfElse"], ["loggedOut", ""], ["noTeams", ""], ["hasTeams", ""], [4, "ngIf", "ngIfThen", "ngIfElse"], [3, "actionLabel", "action"], [4, "ngFor", "ngForOf"], [3, "index", "team", "user", "membership", "dropdownToShow", "newDropdownNumber"]], template: function TeamListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "play-header", 1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementStart(3, "play-button", 2);
        i0.ɵɵlistener("clicked", function TeamListComponent_Template_play_button_clicked_3_listener() { return ctx.joinTeam(); });
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "play-button", 3);
        i0.ɵɵlistener("clicked", function TeamListComponent_Template_play_button_clicked_6_listener() { return ctx.createTeam(); });
        i0.ɵɵtext(7);
        i0.ɵɵpipe(8, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "article", 4);
        i0.ɵɵtemplate(10, TeamListComponent_ng_container_10_Template, 1, 0, "ng-container", 5);
        i0.ɵɵpipe(11, "async");
        i0.ɵɵtemplate(12, TeamListComponent_ng_container_12_Template, 1, 0, "ng-container", 5);
        i0.ɵɵpipe(13, "async");
        i0.ɵɵtemplate(14, TeamListComponent_ng_container_14_Template, 1, 0, "ng-container", 5);
        i0.ɵɵpipe(15, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, TeamListComponent_ng_template_16_Template, 8, 4, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(18, TeamListComponent_ng_template_18_Template, 3, 0, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(20, TeamListComponent_ng_template_20_Template, 3, 3, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = i0.ɵɵreference(17);
        const _r5 = i0.ɵɵreference(19);
        const _r7 = i0.ɵɵreference(21);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("headerTitle", i0.ɵɵpipeBind1(2, 10, "user-team-list:header"))("userPage", true);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 12, "user-team-list:header-join-team"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 14, "user-team-list:header-create-team"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(11, 16, ctx.isReady$))("ngIfThen", _r3);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 18, ctx.isLoading$))("ngIfThen", _r5);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(15, 20, ctx.hasError$))("ngIfThen", _r7);
    } }, directives: [i4.PlayHeaderComponent, i4.ButtonComponent, i5.NgIf, i4.EmptyCallActionComponent, i5.NgForOf, TeamListItemComponent, TeamListItemSkeletonComponent, i4.InlineErrorComponent], pipes: [i2.TranslatePipe, i5.AsyncPipe], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TeamListComponent, [{
        type: Component,
        args: [{
                selector: "user-team-list",
                templateUrl: "./team-list.component.html",
                styleUrls: ["./team-list.component.scss"],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.Store }, { type: i4.LinkService }, { type: i4.Location }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, null); })();

const teamListItemInformationTexts = {
    "user-team-list:part-of": "Part of",
};

function CreateTeamComponent_span_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r1 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(error_r1);
} }
class CreateTeamComponent {
    constructor(store, teamResource, translate, location, linkService) {
        this.store = store;
        this.teamResource = teamResource;
        this.translate = translate;
        this.location = location;
        this.linkService = linkService;
        this.cancel = new EventEmitter();
        this.save = new EventEmitter();
        this.createError$ = new BehaviorSubject(null);
        this.createLoading$ = new BehaviorSubject(false);
        this.teamNames = [
            "Raging Racoons",
            "Way out of our League",
            "Shaolin Monkeys",
            "Top Fraggers",
            "Insert Name Here",
            "Dude where's my AWP?",
            "Chicken Dinner",
        ];
        this.randomTeamName$ = interval(5000)
            .pipe(startWith(0))
            .pipe(map(x => this.teamNames[Math.floor(Math.random() * this.teamNames.length)]), distinctUntilChanged());
    }
    createTeam(teamName) {
        this.createLoading$.next(true);
        this.createError$.next(null);
        this.teamResource
            .createTeam(teamName)
            .toPromise()
            .then(teammembership => {
            this.store.dispatch(new LoadUserTeamsAction(this.memberId));
            this.save.emit(teamName);
            this.location.go(this.linkService.team(+teammembership.team.id));
        })
            .catch(error => {
            if (!error.data || !error.data.error) {
                this.createError$.next(this.getErrorForKey("unknown"));
                return;
            }
            this.createError$.next(this.getErrorForKey(error.data.error));
            return null;
        })
            .then(() => {
            this.createLoading$.next(false);
            this.cancel.emit(true);
        });
    }
    getErrorForKey(errorKey) {
        switch (errorKey) {
            case "name_blacklisted":
            case "no_teamname":
            case "invalid_teamname":
                return this.translate.translate("commons:error-invalid-name", {});
            default:
                return this.translate.translate("commons:error-unknown", {});
        }
    }
}
CreateTeamComponent.ɵfac = function CreateTeamComponent_Factory(t) { return new (t || CreateTeamComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2$1.TeamResource), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i4.Location), i0.ɵɵdirectiveInject(i4.LinkService)); };
CreateTeamComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CreateTeamComponent, selectors: [["user-create-team"]], inputs: { memberId: "memberId" }, outputs: { cancel: "cancel", save: "save" }, decls: 19, vars: 19, consts: [[1, "c-create-team"], ["for", "c-create-team__team-name-input", 1, "c-create-team__label"], [1, "c-create-team__form"], [1, "c-create-team__input-box"], ["id", "c-create-team__team-name-input", "type", "text", "name", "team-name", 1, "c-create-team__input", "play-dialog__text-input", 3, "placeholder", "ngModel", "ngModelChange"], [1, "c-create-team__button"], [1, "c-button--primary", "c-button--big", "c-button--block", 3, "loading", "clicked"], ["class", "play-dialog__error c-create-team__error", 4, "ngIf"], [1, "play-dialog__error", "c-create-team__error"]], template: function CreateTeamComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "p");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "form");
        i0.ɵɵelementStart(5, "label", 1);
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 2);
        i0.ɵɵelementStart(9, "div", 3);
        i0.ɵɵelementStart(10, "input", 4);
        i0.ɵɵlistener("ngModelChange", function CreateTeamComponent_Template_input_ngModelChange_10_listener($event) { return ctx.teamName = $event; });
        i0.ɵɵpipe(11, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 5);
        i0.ɵɵelementStart(13, "play-button", 6);
        i0.ɵɵlistener("clicked", function CreateTeamComponent_Template_play_button_clicked_13_listener() { return ctx.createTeam(ctx.teamName); });
        i0.ɵɵpipe(14, "async");
        i0.ɵɵtext(15);
        i0.ɵɵpipe(16, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(17, CreateTeamComponent_span_17_Template, 2, 1, "span", 7);
        i0.ɵɵpipe(18, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 7, "create-team:create-text"));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 9, "create-team:enter-team-name"), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(11, 11, ctx.randomTeamName$))("ngModel", ctx.teamName);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("loading", i0.ɵɵpipeBind1(14, 13, ctx.createLoading$));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 15, "create-team:create-team"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(18, 17, ctx.createError$));
    } }, directives: [i5$1.ɵangular_packages_forms_forms_ba, i5$1.NgControlStatusGroup, i5$1.NgForm, i5$1.DefaultValueAccessor, i5$1.NgControlStatus, i5$1.NgModel, i4.ButtonComponent, i5.NgIf], pipes: [i2.TranslatePipe, i5.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateTeamComponent, [{
        type: Component,
        args: [{
                selector: "user-create-team",
                templateUrl: "./create-team.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.Store }, { type: i2$1.TeamResource }, { type: i2.TranslateService }, { type: i4.Location }, { type: i4.LinkService }]; }, { memberId: [{
            type: Input
        }], cancel: [{
            type: Output
        }], save: [{
            type: Output
        }] }); })();

class CreateTeamModule {
}
CreateTeamModule.ɵfac = function CreateTeamModule_Factory(t) { return new (t || CreateTeamModule)(); };
CreateTeamModule.ɵmod = i0.ɵɵdefineNgModule({ type: CreateTeamModule });
CreateTeamModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslationModule,
            CommonsModule,
            CommonsErrorModule,
            CommonsLoadingModule,
            CommonsComponentModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CreateTeamModule, { declarations: [CreateTeamComponent], imports: [CommonModule,
        FormsModule,
        TranslationModule,
        CommonsModule,
        CommonsErrorModule,
        CommonsLoadingModule,
        CommonsComponentModule], exports: [CreateTeamComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateTeamModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslationModule,
                    CommonsModule,
                    CommonsErrorModule,
                    CommonsLoadingModule,
                    CommonsComponentModule,
                ],
                exports: [CreateTeamComponent],
                declarations: [CreateTeamComponent],
            }]
    }], null, null); })();

function JoinTeamComponent_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r1 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(error_r1);
} }
class JoinTeamComponent {
    constructor(store, teamResource, translate) {
        this.store = store;
        this.teamResource = teamResource;
        this.translate = translate;
        this.save = new EventEmitter();
        this.cancel = new EventEmitter();
        this.createError$ = new BehaviorSubject(null);
        this.createLoading$ = new BehaviorSubject(false);
    }
    joinTeam(teamId, teamPassword) {
        this.createLoading$.next(true);
        this.createError$.next(null);
        this.teamResource
            .joinTeam(+teamId, teamPassword)
            .toPromise()
            .then((teamMembership) => {
            this.store.dispatch(new LoadUserTeamsAction(this.memberId));
            this.save.emit(teamMembership);
        })
            .catch(error => {
            if (!error.data || !error.data.error) {
                this.createError$.next(this.translate.translate("commons:error-unknown", {}));
                return;
            }
            this.createError$.next(this.translate.translate("join-team:error-" + error.data.error, {}));
            return null;
        })
            .then(() => {
            this.createLoading$.next(false);
            this.cancel.emit(true);
        });
    }
}
JoinTeamComponent.ɵfac = function JoinTeamComponent_Factory(t) { return new (t || JoinTeamComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2$1.TeamResource), i0.ɵɵdirectiveInject(i2.TranslateService)); };
JoinTeamComponent.ɵcmp = i0.ɵɵdefineComponent({ type: JoinTeamComponent, selectors: [["user-join-team"]], inputs: { memberId: "memberId" }, outputs: { save: "save", cancel: "cancel" }, decls: 20, vars: 26, consts: [[1, "c-join-team"], ["for", "c-join-team__team-id-input", 1, "c-join-team__label"], ["id", "c-join-team__team-id-input", "type", "text", "name", "team-name", 1, "c-join-team__input", "play-dialog__text-input", 3, "placeholder", "ngModel", "ngModelChange"], ["for", "c-join-team__team-password-input", 1, "c-join-team__label"], ["id", "c-join-team__team-password-input", "type", "text", "name", "team-name", 1, "c-join-team__input", "play-dialog__text-input", 3, "placeholder", "ngModel", "ngModelChange"], [1, "c-button--primary", "c-button--big", 3, "loading", "clicked"], ["class", "play-dialog__error c-join-team__error", 4, "ngIf"], [1, "play-dialog__error", "c-join-team__error"]], template: function JoinTeamComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "p");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "label", 1);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "input", 2);
        i0.ɵɵlistener("ngModelChange", function JoinTeamComponent_Template_input_ngModelChange_7_listener($event) { return ctx.teamId = $event; });
        i0.ɵɵpipe(8, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "label", 3);
        i0.ɵɵtext(10);
        i0.ɵɵpipe(11, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "input", 4);
        i0.ɵɵlistener("ngModelChange", function JoinTeamComponent_Template_input_ngModelChange_12_listener($event) { return ctx.teamPassword = $event; });
        i0.ɵɵpipe(13, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "play-button", 5);
        i0.ɵɵlistener("clicked", function JoinTeamComponent_Template_play_button_clicked_14_listener() { return ctx.joinTeam(ctx.teamId, ctx.teamPassword); });
        i0.ɵɵpipe(15, "async");
        i0.ɵɵtext(16);
        i0.ɵɵpipe(17, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, JoinTeamComponent_span_18_Template, 2, 1, "span", 6);
        i0.ɵɵpipe(19, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 10, "join-team:join-text"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 12, "join-team:enter-team-id"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(8, 14, "join-team:team-id-placeholder"))("ngModel", ctx.teamId);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 16, "join-team:enter-team-password"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(13, 18, "join-team:team-password-placeholder"))("ngModel", ctx.teamPassword);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("loading", i0.ɵɵpipeBind1(15, 20, ctx.createLoading$));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 22, "join-team:join-team"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(19, 24, ctx.createError$));
    } }, directives: [i5$1.DefaultValueAccessor, i5$1.NgControlStatus, i5$1.NgModel, i4.ButtonComponent, i5.NgIf], pipes: [i2.TranslatePipe, i5.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JoinTeamComponent, [{
        type: Component,
        args: [{
                selector: "user-join-team",
                templateUrl: "./join-team.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.Store }, { type: i2$1.TeamResource }, { type: i2.TranslateService }]; }, { memberId: [{
            type: Input
        }], save: [{
            type: Output
        }], cancel: [{
            type: Output
        }] }); })();

class JoinTeamModule {
}
JoinTeamModule.ɵfac = function JoinTeamModule_Factory(t) { return new (t || JoinTeamModule)(); };
JoinTeamModule.ɵmod = i0.ɵɵdefineNgModule({ type: JoinTeamModule });
JoinTeamModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslationModule,
            CommonsModule,
            CommonsErrorModule,
            CommonsLoadingModule,
            CommonsComponentModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(JoinTeamModule, { declarations: [JoinTeamComponent], imports: [CommonModule,
        FormsModule,
        TranslationModule,
        CommonsModule,
        CommonsErrorModule,
        CommonsLoadingModule,
        CommonsComponentModule], exports: [JoinTeamComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JoinTeamModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslationModule,
                    CommonsModule,
                    CommonsErrorModule,
                    CommonsLoadingModule,
                    CommonsComponentModule,
                ],
                exports: [JoinTeamComponent],
                declarations: [JoinTeamComponent],
            }]
    }], null, null); })();

function LeaveTeamComponent_loading_spinner_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner", 7);
} }
function LeaveTeamComponent_inline_error_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r2 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", error_r2, " ");
} }
const _c0$1 = function (a0) { return { teamName: a0 }; };
class LeaveTeamComponent {
    constructor(store, translate, teamResource) {
        this.store = store;
        this.translate = translate;
        this.teamResource = teamResource;
        this.cancel = new EventEmitter();
        this.save = new EventEmitter();
        this.loadingSubject$ = new Subject();
        this.loadingSubject$.next(false);
        this.loading$ = this.loadingSubject$.asObservable();
        this.leaveErrorSubject$ = new Subject();
        this.leaveErrorSubject$.next("");
        this.leaveError$ = this.leaveErrorSubject$.asObservable();
    }
    leaveTeam() {
        this.leaveErrorSubject$.next("");
        this.loadingSubject$.next(true);
        this.teamResource
            .kickTeamMember(this.teamId, this.memberId)
            .toPromise()
            .catch((error) => {
            this.loadingSubject$.next(false);
            this.leaveErrorSubject$.next(this.getErrorTranslation(error && error.data && error.data.error));
            this.cancel.emit(true);
            return Promise.reject(error);
        })
            .then(() => {
            this.loadingSubject$.next(false);
            this.store.dispatch(new LoadUserTeamsAction(this.memberId));
            this.cancel.emit(true);
        });
    }
    getErrorTranslation(error) {
        const errors = {
            you_are_last_in_team: "leave-team:error-last-in-team",
            invalid_playerId: "leave-team:error-invalid-player-id",
            no_permission: "leave-team:error-no-permission",
            cannot_kick_yourself: "leave-team:error-cannot-kick-yourself",
            cannot_kick_due_leaguerestriction: "leave-team:error-cannot-kick-due-leaguerestriction",
            team_is_locked: "leave-team:error-team-locked",
            cannot_kick_leader: "leave-team:error-cannot-kick-leader",
            cannot_kick_co_leader: "leave-team:error-cannot-kick-coleader",
        };
        const errorKey = errors[error] || "commons:error-unknown";
        return this.translate.translate(errorKey, {});
    }
}
LeaveTeamComponent.ɵfac = function LeaveTeamComponent_Factory(t) { return new (t || LeaveTeamComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i2$1.TeamResource)); };
LeaveTeamComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LeaveTeamComponent, selectors: [["user-leave-team"]], inputs: { teamId: "teamId", teamName: "teamName", memberId: "memberId" }, outputs: { cancel: "cancel", save: "save" }, decls: 15, vars: 18, consts: [[1, "c-confirm-action"], [1, "c-confirm-action__description"], [1, "c-confirm-action__controls"], [1, "c-button", "c-button--big", "c-confirm-action__button", "c-button--destructive", 3, "click"], [1, "c-button--big", "c-button--empty", 3, "clicked"], ["class", "c-confirm-action__spinner", 4, "ngIf"], ["class", "c-confirm-action__error", 4, "ngIf"], [1, "c-confirm-action__spinner"], [1, "c-confirm-action__error"]], template: function LeaveTeamComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelementStart(5, "button", 3);
        i0.ɵɵlistener("click", function LeaveTeamComponent_Template_button_click_5_listener() { return ctx.leaveTeam(); });
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "play-button", 4);
        i0.ɵɵlistener("clicked", function LeaveTeamComponent_Template_play_button_clicked_8_listener() { return ctx.cancel.emit(); });
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, LeaveTeamComponent_loading_spinner_11_Template, 1, 0, "loading-spinner", 5);
        i0.ɵɵpipe(12, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, LeaveTeamComponent_inline_error_13_Template, 2, 1, "inline-error", 6);
        i0.ɵɵpipe(14, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 5, "leave-team:text", i0.ɵɵpureFunction1(16, _c0$1, ctx.teamName)), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 8, "leave-team:leave"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 10, "commons:cancel"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(12, 12, ctx.loading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(14, 14, ctx.leaveError$));
    } }, directives: [i4.ButtonComponent, i5.NgIf, i4.LoadingSpinnerComponent, i4.InlineErrorComponent], pipes: [i2.TranslatePipe, i5.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeaveTeamComponent, [{
        type: Component,
        args: [{
                selector: "user-leave-team",
                templateUrl: "./leave-team.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.TranslateService }, { type: i2$1.TeamResource }]; }, { teamId: [{
            type: Input
        }], teamName: [{
            type: Input
        }], memberId: [{
            type: Input
        }], cancel: [{
            type: Output
        }], save: [{
            type: Output
        }] }); })();

class LeaveTeamModule {
}
LeaveTeamModule.ɵfac = function LeaveTeamModule_Factory(t) { return new (t || LeaveTeamModule)(); };
LeaveTeamModule.ɵmod = i0.ɵɵdefineNgModule({ type: LeaveTeamModule });
LeaveTeamModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslationModule,
            CommonsModule,
            CommonsErrorModule,
            CommonsLoadingModule,
            CommonsComponentModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LeaveTeamModule, { declarations: [LeaveTeamComponent], imports: [CommonModule,
        FormsModule,
        TranslationModule,
        CommonsModule,
        CommonsErrorModule,
        CommonsLoadingModule,
        CommonsComponentModule], exports: [LeaveTeamComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeaveTeamModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslationModule,
                    CommonsModule,
                    CommonsErrorModule,
                    CommonsLoadingModule,
                    CommonsComponentModule,
                ],
                exports: [LeaveTeamComponent],
                declarations: [LeaveTeamComponent],
            }]
    }], null, null); })();

function DeleteTeamComponent_loading_spinner_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner", 7);
} }
function DeleteTeamComponent_inline_error_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r2 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", error_r2, " ");
} }
const _c0 = function (a0) { return { teamName: a0 }; };
class DeleteTeamComponent {
    constructor(store, translate, teamResource) {
        this.store = store;
        this.translate = translate;
        this.teamResource = teamResource;
        this.cancel = new EventEmitter();
        this.save = new EventEmitter();
        this.loadingSubject$ = new Subject();
        this.loadingSubject$.next(false);
        this.loading$ = this.loadingSubject$.asObservable();
        this.deleteErrorSubject$ = new Subject();
        this.deleteErrorSubject$.next("");
        this.deleteError$ = this.deleteErrorSubject$.asObservable();
    }
    deleteTeam() {
        this.deleteErrorSubject$.next("");
        this.loadingSubject$.next(true);
        this.teamResource
            .deleteTeam(this.teamId)
            .toPromise()
            .catch((error) => {
            this.loadingSubject$.next(false);
            this.deleteErrorSubject$.next(this.getErrorTranslation(error && error.data && error.data.error));
            return Promise.reject(error);
        })
            .then(() => {
            this.loadingSubject$.next(false);
            this.store.dispatch(new LoadUserTeamsAction(this.memberId));
            this.cancel.emit(true);
        });
    }
    getErrorTranslation(error) {
        const errors = {
            no_permission: "delete-team:error-no-permission",
            cannot_modify_vendor_team: "delete-team:error-cannot-modify-vendor-team",
            team_has_open_support: "delete-team:error-has-open-support",
            team_has_penalty_points: "delete-team:error-has-penalty-points",
            team_has_members: "delete-team:error-has-members",
            team_is_in_league: "delete-team:error-is-in-league",
        };
        const errorKey = errors[error] || "commons:error-unknown";
        return this.translate.translate(errorKey, {});
    }
}
DeleteTeamComponent.ɵfac = function DeleteTeamComponent_Factory(t) { return new (t || DeleteTeamComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.TranslateService), i0.ɵɵdirectiveInject(i2$1.TeamResource)); };
DeleteTeamComponent.ɵcmp = i0.ɵɵdefineComponent({ type: DeleteTeamComponent, selectors: [["user-delete-team"]], inputs: { teamId: "teamId", teamName: "teamName", memberId: "memberId" }, outputs: { cancel: "cancel", save: "save" }, decls: 15, vars: 18, consts: [[1, "c-confirm-action"], [1, "c-confirm-action__description"], [1, "c-confirm-action__controls"], [1, "c-button", "c-button--big", "c-confirm-action__button", "c-button--destructive", 3, "click"], [1, "c-button--big", "c-button--empty", 3, "clicked"], ["class", "c-confirm-action__spinner", 4, "ngIf"], ["class", "c-confirm-action__error", 4, "ngIf"], [1, "c-confirm-action__spinner"], [1, "c-confirm-action__error"]], template: function DeleteTeamComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelementStart(5, "button", 3);
        i0.ɵɵlistener("click", function DeleteTeamComponent_Template_button_click_5_listener() { return ctx.deleteTeam(); });
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "play-button", 4);
        i0.ɵɵlistener("clicked", function DeleteTeamComponent_Template_play_button_clicked_8_listener() { return ctx.cancel.emit(); });
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, DeleteTeamComponent_loading_spinner_11_Template, 1, 0, "loading-spinner", 5);
        i0.ɵɵpipe(12, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, DeleteTeamComponent_inline_error_13_Template, 2, 1, "inline-error", 6);
        i0.ɵɵpipe(14, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 5, "delete-team:text", i0.ɵɵpureFunction1(16, _c0, ctx.teamName)), " ");
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 8, "delete-team:delete"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 10, "commons:cancel"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(12, 12, ctx.loading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(14, 14, ctx.deleteError$));
    } }, directives: [i4.ButtonComponent, i5.NgIf, i4.LoadingSpinnerComponent, i4.InlineErrorComponent], pipes: [i2.TranslatePipe, i5.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeleteTeamComponent, [{
        type: Component,
        args: [{
                selector: "user-delete-team",
                templateUrl: "./delete-team.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.TranslateService }, { type: i2$1.TeamResource }]; }, { teamId: [{
            type: Input
        }], teamName: [{
            type: Input
        }], memberId: [{
            type: Input
        }], cancel: [{
            type: Output
        }], save: [{
            type: Output
        }] }); })();

class DeleteTeamModule {
}
DeleteTeamModule.ɵfac = function DeleteTeamModule_Factory(t) { return new (t || DeleteTeamModule)(); };
DeleteTeamModule.ɵmod = i0.ɵɵdefineNgModule({ type: DeleteTeamModule });
DeleteTeamModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslationModule,
            CommonsModule,
            CommonsErrorModule,
            CommonsLoadingModule,
            CommonsComponentModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DeleteTeamModule, { declarations: [DeleteTeamComponent], imports: [CommonModule,
        FormsModule,
        TranslationModule,
        CommonsModule,
        CommonsErrorModule,
        CommonsLoadingModule,
        CommonsComponentModule], exports: [DeleteTeamComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeleteTeamModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslationModule,
                    CommonsModule,
                    CommonsErrorModule,
                    CommonsLoadingModule,
                    CommonsComponentModule,
                ],
                exports: [DeleteTeamComponent],
                declarations: [DeleteTeamComponent],
            }]
    }], null, null); })();

class UserTeamsModule {
}
UserTeamsModule.ɵfac = function UserTeamsModule_Factory(t) { return new (t || UserTeamsModule)(); };
UserTeamsModule.ɵmod = i0.ɵɵdefineNgModule({ type: UserTeamsModule });
UserTeamsModule.ɵinj = i0.ɵɵdefineInjector({ providers: [], imports: [[
            CommonModule,
            CommonsLocationModule,
            TranslationModule,
            CommonsErrorModule,
            CommonsComponentModule,
            CreateTeamModule,
            JoinTeamModule,
            LeaveTeamModule,
            DeleteTeamModule,
            SvgIconsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(UserTeamsModule, { declarations: [TeamListComponent,
        TeamListItemComponent,
        TeamListItemSkeletonComponent,
        TeamListItemInformationComponent,
        TeamListItemActionsComponent], imports: [CommonModule,
        CommonsLocationModule,
        TranslationModule,
        CommonsErrorModule,
        CommonsComponentModule,
        CreateTeamModule,
        JoinTeamModule,
        LeaveTeamModule,
        DeleteTeamModule,
        SvgIconsModule], exports: [TeamListComponent,
        TeamListItemComponent,
        TeamListItemSkeletonComponent,
        TeamListItemInformationComponent,
        TeamListItemActionsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserTeamsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    CommonsLocationModule,
                    TranslationModule,
                    CommonsErrorModule,
                    CommonsComponentModule,
                    CreateTeamModule,
                    JoinTeamModule,
                    LeaveTeamModule,
                    DeleteTeamModule,
                    SvgIconsModule,
                ],
                declarations: [
                    TeamListComponent,
                    TeamListItemComponent,
                    TeamListItemSkeletonComponent,
                    TeamListItemInformationComponent,
                    TeamListItemActionsComponent,
                ],
                exports: [
                    TeamListComponent,
                    TeamListItemComponent,
                    TeamListItemSkeletonComponent,
                    TeamListItemInformationComponent,
                    TeamListItemActionsComponent,
                ],
                providers: [],
            }]
    }], null, null); })();

const createTeamTexts = {
    "create-team:create-text": "If you don't already have a team you can create one:",
    "create-team:enter-team-name": "Enter your desired team name:",
    "create-team:create-team": "Create new team",
    "create-team:title": "Create team",
};

const joinTeamTexts = {
    "join-team:error-team_id_missing": "Team ID missing or invalid.",
    "join-team:error-invalid_team_id": "Invalid team ID. Make sure the team exists and the ID is correct.",
    "join-team:error-already_in_team": "You are already a member of this team.",
    "join-team:error-team_has_no_joinpw": "This team does not require a password to join.",
    "join-team:error-wrong_joinpw": "Incorrect team password.",
    "join-team:error-cannot_join_due_leaguerestriction": "You cannot join the team due to tournament restrictions.",
    "join-team:error-team_is_locked": "Team is locked.",
    "join-team:error-team_is_full": "Team is full.",
    "join-team:error-too_many_teams": "Too many teams.",
    "join-team:error-not_allowed_to_join": "You are not allowed to join the team.",
    "join-team:error-not_enough_chars": "Team names need to have at least 3 characters.",
    "join-team:join-text": "To join a team, enter the team's id and password below.",
    "join-team:enter-team-id": "Team ID",
    "join-team:enter-team-password": "Team password",
    "join-team:join-team": "Join team",
    "join-team:team-id-placeholder": "e.g. 154235",
    "join-team:team-password-placeholder": "e.g. mysecretpw",
    "join-team:title": "Join team",
};

const leaveTeamTexts = {
    "leave-team:leave": "Leave",
    "leave-team:text": "Are you sure you wish to leave {teamName}?",
    "leave-team:title": "Leave team",
};

const deleteTeamTexts = {
    "delete-team:delete": "Delete",
    "delete-team:text": "Are you sure you wish to delete {teamName}?",
    "delete-team:title": "Delete team",
};

/**
 * Generated bundle index. Do not edit.
 */

export { CreateTeamComponent, CreateTeamModule, DeleteTeamComponent, DeleteTeamModule, JoinTeamComponent, JoinTeamModule, LeaveTeamComponent, LeaveTeamModule, TeamListComponent, TeamListItemActionsComponent, TeamListItemComponent, TeamListItemInformationComponent, TeamListItemSkeletonComponent, UserTeamsModule, createTeamTexts, deleteTeamTexts, joinTeamTexts, leaveTeamTexts, teamListItemActionsTexts, teamListItemInformationTexts, teamListTexts };
//# sourceMappingURL=play-user-teams.js.map
